<template>
    <div style="position:relative; top:150px;">
        <content-header
            icona="fas fa-users"
            titolo="Personale"
        ></content-header>

        <div class="card sn-card-contenuto">
            <div class="card-body">

                <button type="button" class="btn btn-dark" @click="GetListPersonale()">
                    <i class="fas fa-sync"></i>&nbsp;
                </button>&nbsp;
                <button type="button" class="btn btn-success" @click="EditPersonale()">
                    <i class="fas fa-plus"></i>&nbsp;Aggiungi personale
                </button>&nbsp;
                <br /><br />

                <!-- *** EDIT PERSONALE ***-->
                <a name="editPersonale"></a>
                <div class="bg-edit mt-2 mb-2 p-2 rounded " v-if="mostraEditPersonale">

                    <div class="row rigaSezioneForm m-2">
                        <div class="col-md">
                            <i class="fas fa-edit text-primary"></i>&nbsp;Modifica/Immetti
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Cognome</label>
                            <input type="text" class="form-control" v-model="oPersonale.per_cognome" placeholder="Inserisci Cognome">
                        </div>
                        <div class="mb-3 col-md-6">
                            <label class="form-label">Nome</label>
                            <input type="text" class="form-control" v-model="oPersonale.per_nome" placeholder="Inserisci Nome">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 mb-3">
                            <label class="form-label">Codice Fiscale</label>
                            <input type="text" class="form-control" v-model="oPersonale.per_cf" placeholder="Inserisci Codice Fiscale">
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="form-label">Email</label>
                            <input type="email" class="form-control" v-model="oPersonale.per_email" placeholder="Inserisci Email" :disabled="oPersonale.per_nomail ? true : null">
                        </div>
                        <div class="col-md-6 mb-3">
                            <div class="d-flex form-group pt-5">
                                <input class="form-check-input" type="checkbox" v-model="oPersonale.per_nomail">
                                <label class="form-check-label ms-2">
                                    La persona NON HA una email valida (non potranno essere effettuati quiz).
                                </label>
                            </div>
                            
                        </div>
                    </div>

                    <messaggio-standard 
                        :mostraMessaggio="mostraMessaggioPers"
                        :alertClass="alertClassPers"
                        :alertIcon="alertIconPers"
                        :alertIconSpin="alertIconSpinPers"
                        :alertMessaggio="alertMessaggioPers"
                        fontawesome="standard"
                        ></messaggio-standard>

                    
                    



                    <div class="d-flex">
                        <div class="pe-2"><button type="button" class="btn btn-secondary btn-sm" @click="mostraEditPersonale=false">Annulla</button></div>
                        <div class="pe-2"><button type="button" class="btn btn-primary btn-sm" @click="SalvaPersonale">Salva</button></div>
                    </div>
                    

                </div>

                <!-- **** GRIGLIA PERSONALE **** -->
                <table class="table table-sm table-custom">
                    <thead>
                        <tr>
                            <th>Cod.</th>
                            <th>Cognome</th>
                            <th>Nome</th>
                            <th>Cod. Fisc.</th>
                            <th>Email</th>
                            <th><i class="fas fa-bars fa-fw"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="p, i in dtPersonale" :key="i">
                            <td>{{ p.per_id }}</td>
                            <td>{{ p.per_cognome }}</td>
                            <td>{{ p.per_nome }}</td>
                            <td>{{ p.per_cf }}</td>
                            <td>{{ p.per_email }}</td>
                            <td>
                                <button type="button" class="btn btn-sm btn-outline-primary" title="Modifica" @click="EditPersonale(p.per_id)"><i class="fas fa-edit" title="Edit"></i></button>&nbsp;
                                <button type="button" class="btn btn-sm btn-outline-danger" title="Cancella" @click="DelElemPersonale(p.per_id)"><i class="fas fa-trash fa-fw"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>




            
                

            </div>
        </div>

    </div>
  
    
       
    
</template>

<script>
import snFunctions from '@/lib/snFunctions.js';
import MessaggioStandard from '@/components/MessaggioStandard.vue';
import ContentHeader from '@/components/layout/ContentHeader.vue';

export default {
    name: 'PersonaleView',
    components: {
        ContentHeader, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtPersonale: [],

            oPersonale: {
                per_id: -1,
                per_idAna: -1,
                per_cognome: "",
                per_nome: "",
                per_cf: "",
                per_email: "",
                per_lastLogin: new Date(1900,1,1),
                per_nomail: false,

                token: "",
            },


            mostraEditPersonale: false,

            mostraMessaggioPers: false,
            alertMessaggioPers: "",
            alertClassPers: "",     
            alertIconPers: "",
            alertIconSpinPers: false
           

        }
    },
    methods: {
       
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
        ClearMessaggioPers() {
            this.mostraMessaggioPers = false;
            this.alertMessaggioPers =  "";
            this.alertClassPers = "";
            this.alertIconPers = "";
            this.alertIconSpinPers = false;
        },
        ClearPersonale() {
            this.oPersonale = {
                per_id: -1,
                per_idAna: -1,
                per_cognome: "",
                per_nome: "",
                per_cf: "",
                per_email: "",
                per_lastLogin: new Date(1900,1,1),
                per_nomail: false,

                token: "",
            }
        },


        // *** OPERAZIONI DI BASE SU Personale
        GetListPersonale() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Personale/GetListPersonale?token=" + this.$store.state.UserInfo.token + "&idAna=" + this.$store.state.UserInfo.id)
                .then(response => response.json())
                .then(obj => {
                    this.dtPersonale = obj;
                });
        },
        GetElemPersonale(idelem) {
        //Carica elemento singolo
            fetch(this.cfg.apisrv + "/api/Personale/GetElemPersonale?token=" + this.$store.state.UserInfo.token + "&idPer=" + idelem)
            .then(response => response.json())
            .then(obj => {
                //Dummy format data
                //obj.pst_data = snFunctions.dateFormat(obj.pst_data, "yyyy-MM-dd"); //formatta la data per il campo input
                this.oPersonale = obj;
                this.oPersonale.per_idAna = this.$store.state.UserInfo.id;

                //this.GetListPersonale();
            });
        },
        EditPersonale(id) {
            window.location.href = "#editPersonale";
            this.mostraEditPersonale = true;
            this.ClearPersonale();
            if (id > 0) this.GetElemPersonale(id);
        },
        DelElemPersonale(idelem) {
            //Cancella elemento singolo
            if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv + "/api/Personale/DelElemPersonale?token=" + this.$store.state.UserInfo.token + "&idPer=" + idelem)
                .then(response => response.json())
                .then(obj => {
                    this.GetListPersonale();
                });
            }

        },
        SalvaPersonale() {
            let oSubmit = [];
            oSubmit = this.oPersonale;
            oSubmit.per_idAna = this.$store.state.UserInfo.id;
            oSubmit.token = this.$store.state.UserInfo.token;

            this.ClearMessaggioPers();
            fetch(this.cfg.apisrv + "/api/Personale/SalvaPersonale", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.mostraEditPersonale = false;
                        this.ClearPersonale();
                        this.GetListPersonale(this.$store.state.UserInfo.id);

                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});
                        
                        this.mostraMessaggioPers = true;
                        this.alertMessaggioPers = obj.dati;
                        this.alertClassPers = "alert alert-warning";
                        this.alertIconPers = "fa-xmark"
                        this.alertIconSpinPers = false
                    
                    }
                });

        },



    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListPersonale();
        

    }
}
</script>